<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="waitFunction()" v-bind="attrs" v-on="on" text>
          <v-icon class="mr-2">mdi-map-marker</v-icon><span class="address breakWord">{{pinnedPlace}}</span>
        </v-btn>
      </template>
      <v-card>
  <v-row class=mx-0>
            <v-col cols=10>
              <span class="memexStoryTitle">{{storyTitle}}
                <v-icon class="mr-2">mdi-map-marker</v-icon>
              </span>
            </v-col>
            <v-col cols=2 align="right">
              <v-btn color="red darken-3" text @click="dialog = false" :icon="true">
                <i class="big mdi mdi-close"></i>
              </v-btn>
            </v-col>
                        <v-col cols=10>

            <span class="styleMapAddress breakWord primary--text uppercase--text">{{pinnedPlace}}</span>
                        </v-col>
                                    <v-col cols=2 align="right">
                                    </v-col>
  </v-row>
            <l-map ref="map" :zoom="zoom" :center="center" :options="mapOptions"
              style="height: 85vh;z-index: 2;position:absolute;bottom:0px;left: 0;overflow-y: hidden;">
              <l-tile-layer :url="url" />






              <l-marker v-if="userLocation!=null" :lat-lng="userLocation">
                <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]" :con-size="[1,1]">
                  <img style="width:3vh" :src="require('@/assets/account.png')" />
                </l-icon>
              </l-marker>

              <template v-if="getCurrentAllPublicStories">
                <span v-for="singleStory in getCurrentAllPublicStories" :key="singleStory.id">
                  <l-marker :lat-lng="{'lat':singleStory.latitude,'lng':singleStory.longitude}">
                    <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]">
                      <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                    </l-icon>
                  </l-marker>
                </span>
              </template>

              <!-- user position take from db-->
              <l-control v-if="userLocation!=null" position="bottomright">
                <v-btn class="floatingBtn" icon large>
                  <a
                    :href="'https://www.google.com/maps/dir/?api=1&origin=' + userLocation.lat + ',' + userLocation.lng + '&destination='+ marker.lat + ','+ marker.lng +'&travelmode=walking'">
                    <img style="width:6vh" :src="require('@/assets/direction.png')" />
                  </a>
                </v-btn>
              </l-control>
              
            </l-map>

      </v-card>
    </v-dialog>

</template>

<script>
import {
  Touch
} from "vuetify/lib/directives"

import dialogMixin from "vue-dialog-mixin"
import 'leaflet/dist/leaflet.css';
import {
  latLng
} from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LControl
} from "vue2-leaflet";
export default {
  name: "singleStoryMapView",
  mixins: [dialogMixin],
  data() {
    return {
      model: null,
      apiUrl: process.env.VUE_APP_ROOT_API,
      pinnedPlace: "",
      userLocation: null,
      maploaded: false,
      cache: {},
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      staticAnchor: [16, 37],
      zoom: 30,
      center: latLng(44.8377720, 11.6186548),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      currentZoom: 8,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
    }
  },
  directives: {
    Touch
  },
  components: {

    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControl,
  },
  async mounted() {
    this.center = this.marker
    this.userLocation = {
      lat: this.$store.getters.getUser.latitude,
      lng: this.$store.getters.getUser.longitude
    }

    this.pinnedPlace = await this.retrivePositionMarkerPlace(this.marker)
    this.pinnedPlace = this.pinnedPlace.data.info
  },
  methods: {
    openDialogDetail (){
      this.dielogDetail = true;
    },



    waitFunction() {
      //this is a workaround for the map to load correctly since the leaflet component has a bug
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize()
      }, 100)
    },
    retrivePositionMarkerPlace: async function (markerposition) {
      try {
        return this.getaxiosResponse(this.apiUrl + '/getGeoLocationInfo?lat=' + markerposition.lat + '&lon=' + markerposition.lng)
      } catch (error) {
        if (error.status === 400) {
          
          // Handle error.
        }
        // Handle error.
        else {
          console.log(error);
        }
      }
    },
  },
    computed: {
    getCurrentAllPublicStories: {
      get: function () {
        return this.$store.getters.getCurrentAllPublicStories;
      }
    }
    },
  props: {
    marker: {
      type: Object,
      required: false
    },
    storyTitle: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>

.leaflet-top.leaflet-right{
bottom:0px!important;
}
.address{
width: 15rem;
font-size: 0.6rem;
}
.styleMapAddress{
  font-size: 0.8rem;
}
.maxwidth{
  width:200px;
}
.sliderCoverImg{
    width: 100%;
    height: auto;
    max-width: 200px;
    box-sizing:content-box;
}
.v-application p{
  margin-bottom: 0px;
}
.uppercase--text{
  text-transform: uppercase;
}
.breakWord{
  font-size: 65%;
     overflow-wrap: break-word;
     max-width: 40vh;
}
.square {
      border-radius:5%;
      border:2px solid black;
min-width: 20vh;
min-height: 20vh;
word-wrap: break-word;
  background-color: #888;
}
.circle {
  height: 5vh;
  width: 5vh;
  background-color: #555;
  border-radius: 50%;
}
</style>